export default {
  master(state) {
    return state.master
  },

  susseeded(state) {
    return state.susseeded
  },

  lastBookingID(state) {
    return state.lastBookingID
  },

  newUserModal(state) {
    return state.newUserModal
  },

  bookingWindow(state) {
    return state.bookingWindow
  },
  bookingWindows(state) {
    return state.bookingWindows
  },
  bookingLoad(state) {
    return state.bookingLoad
  },
  timeBtnClicked(state) {
    return state.timeBtnClicked
  },
  booking(state) {
    return state.booking
  },
  bookings(state) {
    return state.bookings
  },
  bookingStatuses(state) {
    return state.bookingStatuses
  },
  bookingsFilters(state) {
    return state.bookingsFilters
  },
  newBookings(state) {
    return state.newBookings
  },
  currentNewBooking(state) {
    return state.currentNewBooking
  },
  bookingPaymentHistory(state) {
    return state.bookingPaymentHistory
  },
  bookingHistory(state) {
    return state.bookingHistory
  },
}
